import PropTypes from 'prop-types';
import styled from 'styled-components';
import React from 'react';
import { Radio } from 'antd';

const StyledRadioDiv = styled.div`
  display: flex;
  margin-left: 20px;
  font-size: 16px;
  width: 40%;
  padding-top: 30px;
  .ant-radio-group {
    margin-top: -8px;
  }
`;

const StyledRadioText = styled.p`
  margin-top: 5px;
`;

const RadioGroup = styled(Radio.Group)`
`;

const StyledRadio = styled(Radio)`
  display: block;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  margin-left: 10px;
`;

const RadioButtons = ({ onChange, name, values, title }) =>
  <StyledRadioDiv>
    <StyledRadioText>
      {title}
    </StyledRadioText>
    <RadioGroup name={name} onChange={onChange} defaultValue={values[0]?.key}>
      {values?.map(v =>
        <StyledRadio key={v.key} value={v.key}>{v.description}</StyledRadio>,
      )}
    </RadioGroup>
  </StyledRadioDiv>;
RadioButtons.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  values: PropTypes.array,
  title: PropTypes.string,
};

export default RadioButtons;
